import { BaseReq, PaginationReq, PaginationResp } from "@/core/interface";

export class FileReq extends BaseReq {
  bizId: string = "";
  bizType: string = "";
  name: string = "";
  url: string = "";
  size: number = 0;
  suffix: string = "";
}

export class FilePageReq extends PaginationReq {
  bizId: string = "";
  bizType: string = "";

  constructor(req = {}) {
    super();
    this.merge(req);
  }
}

export class FileRecord extends FileReq {
  id: number = 0;
  tenantId: string = "";
  createName: string = "";
  createTime: string = "";
}

export class FilePageResp extends PaginationResp<FileRecord> {}

export class MoveReq {
  bizType: string = ""
  ids: Array<String> = []
  newBizId: string = ""

}
